import React from 'react';
import { motion } from 'framer-motion';
import styles from './Advt.module.css';
import { useGetParams } from '../../hooks/useGetParams';

import logo from '../../assets/images/logo.png';

const Advt = React.memo(() => {
  const { qrCode1, qrCode2 } = useGetParams();

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
      className={styles.wrapper}
    >
      <img src={logo} alt="" className={styles.logo} />
      <div className={styles.title}>Присылай свой вариант</div>

      <div className={styles.qrBlock}>
        {qrCode1 && (
          <div className={styles.qrCode}>
            <img src={qrCode1} alt="qrCode1" />
          </div>
        )}
        {qrCode2 && (
          <div className={styles.qrCode}>
            <img src={qrCode2} alt="qrCode1" />
          </div>
        )}
      </div>
    </motion.div>
  );
});

export default Advt;
